
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-do-dont-cards'
	});

	const { attributes, setAttributes } = props;
	const { contentDo, contentDont } = attributes;

	return (
		<div {...blockProps}>
			<RichText
				tagName='div'
				className='c4l-do-dont-cards-do'
				multiline='p'
				value={contentDo}
				onChange={(newVal) => setAttributes({ contentDo: newVal })}
				placeholder={__("Type the Do Card content here", 'do-dont-cards')}
			/>
			<RichText
				tagName='div'
				className='c4l-do-dont-cards-dont'
				multiline='p'
				value={contentDont}
				onChange={(newVal) => setAttributes({ contentDont: newVal })}
				placeholder={__("Type the Don't Card content here", 'do-dont-cards')}
			/>
		</div>
	);
}
